/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cupcakes_TitleInputs */

const en_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes`)
};

const ar_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كب كيك`)
};

const de_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes`)
};

const es_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes`)
};

const fr_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes`)
};

const it_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake`)
};

const ja_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カップケーキ`)
};

const ko_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컵케이크`)
};

const pt_br_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes`)
};

const ru_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Капкейки`)
};

const th_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัพเค้ก`)
};

const tr_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake'ler`)
};

const zh_cn_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纸杯蛋糕`)
};

const zh_tw_cupcakes_title = /** @type {(inputs: Cupcakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`杯子蛋糕`)
};

/**
* | output |
* | --- |
* | "Cupcakes" |
*
* @param {Cupcakes_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cupcakes_title = /** @type {((inputs?: Cupcakes_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cupcakes_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cupcakes_title(inputs)
	if (locale === "ar") return ar_cupcakes_title(inputs)
	if (locale === "de") return de_cupcakes_title(inputs)
	if (locale === "es") return es_cupcakes_title(inputs)
	if (locale === "fr") return fr_cupcakes_title(inputs)
	if (locale === "it") return it_cupcakes_title(inputs)
	if (locale === "ja") return ja_cupcakes_title(inputs)
	if (locale === "ko") return ko_cupcakes_title(inputs)
	if (locale === "pt_br") return pt_br_cupcakes_title(inputs)
	if (locale === "ru") return ru_cupcakes_title(inputs)
	if (locale === "th") return th_cupcakes_title(inputs)
	if (locale === "tr") return tr_cupcakes_title(inputs)
	if (locale === "zh_cn") return zh_cn_cupcakes_title(inputs)
	return zh_tw_cupcakes_title(inputs)
});